(() => {
  if (window.NubsPageLifecycle) return;
  const controllers = new Set();
  function scope() {
    const controller = new AbortController();
    const cleanups = [];
    controllers.add(controller);
    controller.signal.addEventListener('abort', () => {
      controllers.delete(controller);
      cleanups.forEach(fn => {try{fn();}catch(_){}});
    }, {once:true});
    return {
      listen(target,type,listener,options={}) {target.addEventListener(type,listener,{...(typeof options==='boolean'?{capture:options}:options),signal:controller.signal});},
      cleanup(fn) {cleanups.push(fn);},
      get active(){return !controller.signal.aborted;},
    };
  }
  document.addEventListener('nubs:beforepagechange',() => {
    const leaving=[...controllers];
    // Let gallery close/focus handlers finish before removing page listeners.
    queueMicrotask(()=>leaving.forEach(controller=>controller.abort()));
  });
  window.NubsPageLifecycle={scope};
})();
